import { render } from "./CampusTable.vue?vue&type=template&id=2d5a06b0"
import script from "./CampusTable.vue?vue&type=script&lang=js"
export * from "./CampusTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/bastien/a38/esiea-erp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtn,QSelect,QInput,QIcon,QTd,QDialog,QCard,QCardSection,QAvatar,QSpinner,QCardActions});qInstall(script, 'directives', {ClosePopup});
